import {logout} from '../apis/authenticate';
import { clearAlertsMetadata } from '../slices/alertsMetadataSlice';
import { clearAlerts } from '../slices/alertsSlice';
import { clearApplicationSummary } from '../slices/appSummarySlice';
import { clearDictionary } from '../slices/dictionarySlice';
import { clearEmployee } from '../slices/employeeSlice';
import { clearEmployer } from '../slices/employerSlice';
import { clearLoanDetails } from '../slices/loanDetailsSlice';
import { clearPayroll } from '../slices/payrollSlice';
import { clearPrimaryBank } from '../slices/primaryBankSlice';
import { clearQueues } from '../slices/queueSlice';
import { clearProgress } from '../utils/GotItUtils';

import { useAppDispatch } from '.';

const useLogout = () => {

    const dispatch = useAppDispatch();


    const logoutUser = async (reload:boolean = true) => {
        await logout();
        dispatch(clearAlertsMetadata());
        dispatch(clearAlerts());
        dispatch(clearApplicationSummary());
        dispatch(clearDictionary());
        dispatch(clearEmployee());
        dispatch(clearEmployer());
        dispatch(clearLoanDetails());
        dispatch(clearPayroll());
        dispatch(clearPrimaryBank());
        dispatch(clearQueues());
        
        clearProgress();
        // don't want to clear this because it removes "no-session state", which is needed for routing
        // dispatch(clearUser());

        if(reload){
            window.location.reload();
        }
    };

    return {logoutUser};
};

export default useLogout;
